<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <router-link to="teachingEvaluation">
          <span class="subtitle">干部培训课程质量评估</span>
        </router-link>
        <div class="head_title_font class_head_title_font">
          <span>干部教学培训质量评估</span>
        </div>
      </div>
      <div class="body_content class_body_content">

        <div style="margin: 20px;" v-if="currentQuestionnaireId">
          <div class="evaluation teacher_introduce">
            <b>评估人数：</b>{{details_numStudent_name}}
            <!--<b>type:</b>{{details_type}}-->
          </div>
          <div class="evaluation evaluation_all">
            <table class="table table-striped table-bordered">
              <thead>
              <tr v-if="currentQuestionnaire.filter(i=>i.type=='1').length>0">
                <th v-for="q in currentQuestionnaire" v-if="q.type == '1'" :colspan="q.colspan">{{q.title}}（{{q.maxValue}}）</th>
                <th></th>
              </tr>
              <tr>
                <th v-for="q in currentQuestionnaire" v-if="q.type != '1'">{{q.title}}（{{q.maxValue}}）</th>
                <th>总分（{{ totalScore }}）</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(clazzEvaluation,index) in clazzEvaluationList" :key="index">
                <td v-for="(q, i) in currentQuestionnaire.filter(i=>i.type!='1')" v-if="q.type != '1'">{{clazzEvaluation['item'+(i+1)]}}</td>
                <td>{{clazzEvaluation.score}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="evaluation evaluation_details">
            <table class="table table-striped table-bordered other_tab">
              <thead>
              <tr>
                <th width="20%">评估学员</th>
                <th width="10%">总给分（100）</th>
                <th width="60%">其他建议</th>
                <th width="10%">详情</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(studentEvalua,index) in studentEvaluationList" :key="index">
                <td width="20%">**</td>
                <td width="10%">{{studentEvalua.score}}</td>
                <td width="60%">{{studentEvalua.content}}</td>
                <td width="10%">
                  <div class="details_pic" v-on:mouseover="student_id=studentEvalua.id;isShowDiv=true;getStudentScoreDetails($event)" v-on:mouseout="isShowDiv=false"></div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else>
          <div style="margin: 20px;font-size: 16px;text-align: center;">暂未评估</div>
        </div>
         <div id="showme_details" class="float_deteils_div" :class="{isShowDivClass: isShowDiv}">
          <div class="scroeDetail" >
            <p v-for="(q, i) in currentQuestionnaire.filter(i=>i.type!='1')"><b>{{q.title}}:</b>{{studentScoreDetailsrespList['item'+(i+1)]}}</p>
          </div>
        </div>
      </div>

    </div>



  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';

  export default {
    name: "teachingEvaluation",
    data(){
      return{
        clazzId: this.$store.state.clazzId,
        clazzEvaluationList: [],
        studentEvaluationAvgList: [],
        studentEvaluationList: [],
        studentScoreDetailsrespList: {},

        page:'',
        rows:'',
        type:'',

        details_lesson_id: '',
        details_lesson_name: '',
        details_teacher_name: '',
        details_startDate_name: '',
        details_numStudent_name: '',
        details_type:'',

        student_id: '',

        name:'',

        isShowDiv: false,

        checkbox: {
          checkIds: [],
        },


        currentQuestionnaireId:"",
        currentQuestionnaire:[],
        token: this.$store.state.access_token,
        serviceBase:this.$store.state.serviceBase,
        hrefExport:this.$store.state.serviceBase+"resources/",
        totalScore:0
      }
    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //刷新页面首次加载
        this_.initEvaluationListData();
      });
    },
    methods: {
      initEvaluationListData() {
        let this_ = this;
        schoolAxios({
          method: 'post',
          url: 'evaluate/findClazzEvaluates',
          data: {
            clazzId: this_.clazzId,
            name: this_.name,
            page: '1',
            rows: '9999'
          }
        }).then(function (resp) {
          /* console.log(resp)*/
          this_.clazzEvaluationList = resp.data.list;
          if(this_.clazzEvaluationList.length>0)
            this_.getDetails(this_.clazzEvaluationList[0]);
        });
      },
      initEvaluationTemplate(id, callback){
        if(this.currentQuestionnaireId == id){
          if(callback) callback.call(this);
          return;//同一评估ID跳过
        }
        this.currentQuestionnaireId = id;
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'questionnaire/getItemlistById',
          params: {
            id: id
          }
        }).then(function (resp) {
          if(resp.data.success){
            this_.currentQuestionnaire = resp.data.list;

            let colspan = 0
            let cItem;
            this_.totalScore = 0;
            this_.currentQuestionnaire.forEach(item => {
              if(item.type == '1'){
                if(cItem && colspan) {
                  cItem.colspan = colspan;
                }
                colspan = 0;
                cItem = item;
              }else{
                colspan ++;
                this_.totalScore += Number(item.maxValue)
              }
            })
            if(cItem && colspan){
              cItem.colspan = colspan;
            }

            if(callback) callback.call(this);
          }
        });
      },
      /**
       * 查询详情
       */
      getDetails(clazzEvaluation){
        this.details_lesson_id=clazzEvaluation.id;
        this.details_lesson_name=clazzEvaluation.name;
        this.details_teacher_name=clazzEvaluation.teacherName;
        this.details_startDate_name=clazzEvaluation.startDate;
        this.details_numStudent_name=clazzEvaluation.contentNum;
        let this_ = this;
        this.initEvaluationTemplate(clazzEvaluation.questionnaireId, function () {

          schoolAxios({
            method: 'get',
            url: 'evaluate/clazzEvaluateMsg',
            params: {
              dataId: this_.clazzId
            }
          }).then(function (studentresp) {
            if (studentresp.data.success) {
              this_.studentEvaluationList = studentresp.data.list;
            }
          });
        });
      },
      getStudentScoreDetails(event){
        $("#showme_details").css("left", event.pageX-120).css("top", event.pageY-150);
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'evaluate/load/'+this_.student_id,
          params: {
          }
        }).then(function (studentScoreDetailsresp) {
          /*console.log(studentScoreDetailsresp)*/
          if(studentScoreDetailsresp.data.success){
            this_.studentScoreDetailsrespList = studentScoreDetailsresp.data.data;
          }
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .table {
    color: #FFFFFF;
  }
  .table th {
    color: black;
    background-color: #cccccc;
  }
  .table tr{
    color: black;
    background-color: #FFFFFF;
  }
  .table,.table th {
    text-align: center;
  }
  /*.tabletd{
    width: 140px;
  }
  .tablexuhao{
    width: 90px;
  }*/
  .class_body_content_self {
    width: 100%;
    height: auto;
    /*margin-top: 30px;*/
  }
  .details_pic {
    margin: auto;
    width: 29px;
    height: 22px;
    /*background-image: url("../img/right/teachingEvaluation/details_disabled.png");*/
    background-image: url("../assets/img/right/clazz/details_mouseOver.png");
    background-size: 100% 100%;
  }
  /*.details_pic:hover{
    background-image: url("../img/right/teachingEvaluation/details_mouseOver.png");
  }*/

  .modal-dialog {
    width: 60%;
    /*height: 80%;*/
  }
  .modal-content {
    width: 100%;
    /*height: 100%;*/
  }
  .modal-title {
    text-align: center;
  }
  .modal-header {
    height: 8%;
  }
  .modal-body {
   /* height: 92%;*/
  }

  .teacher_introduce {
    width: 100%;
    height: 6%;
  }
  .evaluation_all {
    width: 100%;
    height: 16%;
  }
  .evaluation_details {
    width: 100%;
    /*height: 78%;*/
    overflow: auto;
  }
  .evaluation_details table {
    width: 100%;
    /*max-height: 96%;*/
    overflow: auto;
  }

  .float_deteils_div {
    padding: 20px;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 180px;
    overflow: hidden;
    z-index: 2000;
    background-color: white;
    display: none;
    border: 1px solid black;
  }
  .isShowDivClass {
    display: block;
  }
  .scroeDetail{
    text-align: center;
  }
  .classEvaluationScore {
    overflow: hidden;
  }

  /*
  .other_tab tr td {
    height: 40px;
  }
  */


  /*教学评估列表表头固定*/
  .tbl_evaluation thead tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tbl_evaluation tbody{
    /*display: block;
    height: 450px;*/
    /*overflow-y: scroll;*/
    overflow: auto;
  }
  .tbl_evaluation tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tbl_evaluation{
    border: none;
  }
  .tbl_evaluation tbody::-webkit-scrollbar{
    width:0;
  }

  /*教学评估模态框表头固定*/
  .other_tab thead tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .other_tab tbody{
    /*display: block;*/
    /*height: 450px;*/
    /*overflow-y: scroll;*/
    overflow: auto;
  }
  .other_tab tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .other_tab{
    border: none;
  }
  .other_tab tbody::-webkit-scrollbar{
    width:0;
  }
  .searcharea{
    margin: 10px;
  }
  .subtitle{
    display: inline-block;
    font-size: 14px;
    color: #3c3c3c;
    line-height: 40px;
    margin: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/clazzEvaluation.vue